// Editable site-wide content. Verified company contact details can be added to `contact` later.
export const brand = {
  name: "TechCare Technologies",
  mantra: "Technology That Cares.",
  philosophy: "Where Innovation Meets Care.",
  promise: "You take care of business. We take care of the tech.",
  domain: "https://techcare.live",
  country: "Kenya",
};

// Verified, owner-approved public contact details only. Both numbers confirmed on WhatsApp (Phase 3I).
// The Australian number is an international contact line, not an office. Nairobi address approved for publication (Phase 4A).
export const contact = {
  email: "hello@techcare.live",
  phones: [
    { id: "ke", region: "Kenya", display: "+254 728 773 764", tel: "+254728773764", whatsapp: "https://wa.me/254728773764" },
    { id: "au", region: "Australia", display: "+61 481 865 742", tel: "+61481865742", whatsapp: "https://wa.me/61481865742" },
  ],
  address: { label: "Nairobi office", lines: ["Unga House", "Room 920, 9th Floor", "Westlands, Nairobi, Kenya"] },
  socials: [],
};

export const nav = [
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/#industries" },
  { label: "Our Name", to: "/#our-name" },
  { label: "Brendan", to: "/brendan" },
  { label: "Care-Shop", to: "/shop" },
];

export const care = [
  {
    letter: "C",
    word: "Continuity",
    line: "Keeping businesses, infrastructure and essential operations connected and functioning.",
    detail: "Networks that stay up, systems that are maintained and plans for when the unexpected happens.",
  },
  {
    letter: "A",
    word: "Advancement",
    line: "Embracing emerging technology and innovation to create progress.",
    detail: "AI, automation, drones and modern software — applied where they move an organisation forward.",
  },
  {
    letter: "R",
    word: "Reliability",
    line: "Delivering dependable solutions and support.",
    detail: "Doing the work properly, documenting it clearly and standing behind it.",
  },
  {
    letter: "E",
    word: "Enterprise",
    line: "Combining an enterprising mindset with technology to create opportunity and growth.",
    detail: "Seeing technology as a lever for opportunity — for our clients and the communities around them.",
  },
];

export const industries = [
  {
    id: "construction",
    name: "Construction",
    image: "/images/construction-nairobi.jpg",
    imageAlt: "High-rise building under construction in Nairobi with a tower crane",
    lead: "Sites change every week. Technology should keep up.",
    cases: [
      "Drone mapping and progress imagery to compare a site against plan",
      "Temporary site connectivity for site offices and teams",
      "CCTV and access control to help protect materials and equipment",
      "Structured cabling and network fit-out as buildings near handover",
    ],
  },
  {
    id: "energy",
    name: "Energy",
    image: "/images/solar.jpg",
    imageAlt: "Rows of solar panels in an open field",
    lead: "Remote assets need reliable eyes and links.",
    cases: [
      "Fixed wireless links to connect remote plant and installations",
      "Drone inspection of panels, structures and hard-to-reach assets",
      "Monitoring of agreed infrastructure so faults are spotted earlier",
      "Field engineering for installation, inspection and decommissioning",
    ],
  },
  {
    id: "education",
    name: "Education",
    image: "/images/students-it.jpg",
    imageAlt: "Students learning to code in a computer class",
    lead: "Learning depends on technology that simply works.",
    cases: [
      "Campus Wi-Fi planned for classrooms, libraries and halls",
      "Computer lab procurement, setup and asset tagging",
      "AV systems for lecture rooms and hybrid learning",
      "Web platforms and portals for students and staff",
    ],
  },
  {
    id: "commercial",
    name: "Commercial Facilities",
    image: "/images/nairobi-day.jpg",
    imageAlt: "Nairobi city skyline with commercial buildings on a clear day",
    lead: "Offices, retail and mixed-use spaces that run smoothly.",
    cases: [
      "Enterprise networking and Wi-Fi across floors and tenants",
      "Meeting room AV and video conferencing",
      "CCTV and access control planning and installation",
      "Managed IT support for day-to-day operations",
    ],
  },
  {
    id: "other",
    name: "Other Sectors",
    image: "/images/engineer-dc.jpg",
    imageAlt: "Engineer working with network equipment",
    lead: "Healthcare, hospitality, logistics, NGOs and SMEs.",
    cases: [
      "Hardware and software for growing teams",
      "Automation and AI assistants for repetitive work",
      "Security assessments and endpoint protection",
      "Custom software and integrations between existing systems",
    ],
  },
];

export const approach = [
  ["Listen", "We start with your operations, constraints and goals — not with a product to sell."],
  ["Survey", "Where it matters, we go on site to see the real environment before we design anything."],
  ["Design", "We propose a clear, right-sized solution with scope, assumptions and next steps written down."],
  ["Deliver", "Our teams deploy carefully, test thoroughly and document what was done."],
  ["Care", "We stay involved — supporting, maintaining and improving what we've delivered."],
];

export const shopCategories = [
  { name: "Laptops", icon: "Laptop" },
  { name: "Desktops", icon: "Monitor" },
  { name: "Printers", icon: "Printer" },
  { name: "Networking", icon: "Router" },
  { name: "Drones", icon: "Plane" },
  { name: "CCTV Cameras", icon: "Cctv" },
  { name: "Smart Devices", icon: "Smartphone" },
  { name: "Accessories", icon: "Cable" },
];

export const enquiryTypes = [
  { id: "quote", label: "Request a Quote", hint: "Pricing for a defined piece of work, equipment or ongoing service." },
  { id: "site_survey", label: "Book a Site Survey", hint: "An on-site visit to assess your space, infrastructure or project before we propose anything." },
  { id: "consultation", label: "Consultation", hint: "A conversation to explore an idea, challenge or technology decision." },
];

// Optional corporate enquiry details. Values must match the backend Literal lists in server.py exactly.
export const enquiryOptions = {
  industry: ["Construction", "Energy", "Education", "Commercial Facilities", "Healthcare", "Hospitality", "Logistics",
    "NGO / Non-profit", "Government / Public sector", "Small or medium business", "Other"],
  project_timeline: ["As soon as possible", "Within 1 month", "1–3 months", "3–6 months", "More than 6 months", "Not sure yet"],
  budget_range: ["Under KES 100,000", "KES 100,000–499,999", "KES 500,000–1,999,999", "KES 2,000,000 and above",
    "Not sure / Request a quotation", "Prefer not to disclose"],
  preferred_contact: ["Email", "Phone call", "WhatsApp", "No preference"],
};
